import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})

/**
 * Library of methods returning literal formats of date
 * and time translated according to the language of the user.
 * It use the i18n Internationalization TanslateService and
 * the Angular DatePipe.
 */
// TODO Give to the DatePipe service
export class DateFormatterService {

  readonly whiteSpace = ' ';

  constructor(private translate: TranslateService) { }

  /**
   * Return the two date passed with the following format
   * "From [first date and hour] To [second date and hour]"
   *
   * @param firstDate
   * @param secondDate
   */
  fromToShortDateTime(firstDate: Date, secondDate: Date) {
    return this.translate.instant('DATE.FROM') + this.whiteSpace
      + formatDate(firstDate, 'short',  this.translate.currentLang) + this.whiteSpace
      + this.translate.instant('DATE.TO') + this.whiteSpace
      + formatDate(secondDate, 'short',  this.translate.currentLang);
  }

  /**
   * Return the two date passed with the following format
   * "From [first hour] To [second hour]"
   *
   * @param firstTime
   * @param secondTime
   */
  fromToShortTime(firstTime: Date, secondTime: Date) {
    return this.translate.instant('TIME.FROM') + this.whiteSpace
      + formatDate(firstTime, 'shortTime',  this.translate.currentLang) + this.whiteSpace
      + this.translate.instant('TIME.TO') + this.whiteSpace
      + formatDate(secondTime, 'shortTime',  this.translate.currentLang);
  }

  /**
   * Return a full ISO 8601
   *
   * @param duration partial ISO8601 duration
   */
  fullIso6801Duration(duration: string) {
    const split = duration.split('T');
    let unitsFound: string[] = [];

    if (split[0]) {
      split[0] = split[0].replace('P', '');
      unitsFound = split[0].match(/(Y|M|D)/g) || [];
      if (!unitsFound.includes('D')) {
split[0] = split[0] + '0D';
}
      if (!unitsFound.includes('M')) {
split[0] = '0M' + split[0];
}
      split[0] = '0Y' + split[0];
    } else {
      split[0] = '0Y0M0D';
    }

    if (split[1]) {
      unitsFound = split[1].match(/(H|M|S)/g) || [];
      if (!unitsFound.includes('M')) {
split[1] = split[1] + '0M';
}
      split[1] = split[1] + '0S';
      if (!unitsFound.includes('H')) {
split[1] = '0H' + split[1];
}
    } else {
      split[1] = '0H0M0S';
    }
    return 'P' + split.join('T');
  }

  /**
   * Take the UTC Hours and Minutes of the given date
   * and return a new todays date with this times.
   */
  todayFromTime(date: Date): Date {
    const today = new Date();

    today.setHours(date.getUTCHours());
    today.setMinutes(date.getUTCMinutes());
    today.setSeconds(0);
    today.setMilliseconds(0);

    return today;
  }

  /**
   * Return the date passed with the following format
   * "Until [date and hour]"
   *
   * @param date
   */
  untilShortDateTime(date: Date) {
    return this.translate.instant('UNTIL.DATE') + this.whiteSpace
      + formatDate(date, 'short', this.translate.currentLang);
  }

  /**
   * Return the date passed with the following format
   * "Until [hour]"
   *
   * @param date
   */
  untilShortTime(date: Date) {
    return this.translate.instant('UNTIL.TIME') + this.whiteSpace
      + formatDate(date, 'shortTime', this.translate.currentLang);
  }
}
